import AuthenticationApi from '../api/authentication';
import createdPersistedState from "vuex-persistedstate";

const AUTHENTICATING = "AUTHENTICATING",
      AUTHENTICATING_SUCCESS = "AUTHENTICATING_SUCCESS",
      AUTHENTICATING_ERROR = "AUTHENTICATING_ERROR";

export default {
    namespaced: true,
    state: {
        isLoading: false,
        error: null,
        authenticated: true,
        user_role: user_role,
        access_token: admin_token,
        refresh_token: JSON.parse(localStorage.getItem('refresh_token') || "null")
    },
    plugins: [createdPersistedState],
    getters: {
        isLoading(state) {
            return state.isLoading;
        },
        hasError(state) {
            return state.error !== null;
        },
        error(state) {
            return state.error;
        },
        isAuthenticated(state) {
            return state.authenticated;
        },
        accessToken(state) {
            return state.access_token;
        },
        refreshToken(state) {
            return state.refresh_token;
        }
    },
    mutations: {
        [AUTHENTICATING](state) {
            state.isLoading = true;
            state.error = null;
        },
        [AUTHENTICATING_SUCCESS](state, response) {
            state.isLoading = false;
            state.error = null;
            state.access_token = response.access_token;
            localStorage.setItem("access_token", JSON.stringify(state.access_token));
            state.refresh_token = response.refresh_token;
            localStorage.setItem("refresh_token", JSON.stringify(state.refresh_token));
            state.authenticated = true;
            state.user_role = localStorage.getItem('user_role');
            state.user = localStorage.getItem('user');
        },
        [AUTHENTICATING_ERROR](state, error) {
            state.isLoading = false;
            state.error = error;
            state.token = null;
            state.authenticated = false;
            localStorage.removeItem("user_role");
            localStorage.removeItem("user");
        },
    },
    actions: {
        async authenticate({ commit }, params) {
            commit(AUTHENTICATING);
            try {
                let response = await AuthenticationApi.authenticate(params);
                commit(AUTHENTICATING_SUCCESS, response.data);
                return response.data;
            } catch (error) {
                commit(AUTHENTICATING_ERROR, error);
                return null;
            }
        },
    }
}



// WEBPACK FOOTER //
// ./src/store/authentication.js